import * as ActionTypes from '../../constants/actiontypes/funecap/activityLog';
import * as Loadings from '../../constants/loadings/funecap/activityLog';
import * as R from 'ramda';
import ActivityLog from '../../constants/models/activityLog';
import { pageLimit } from '../../constants/paginations/paginationLimit';

const ActivityLogReducer = (state = {
    isLoading: [],
    items: [],
    continuationToken: undefined,
}, action) => {
    switch (action.type) {

        case ActionTypes.FETCH_ACTIVITYLOG_REQUEST:
            if (!state.isLoading.includes(Loadings.FETCHING_ACTIVITYLOG)) {
                state.isLoading = state.isLoading.concat(Loadings.FETCHING_ACTIVITYLOG);
            }
            return { ...state };

        case ActionTypes.FETCH_ACTIVITYLOG_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.FETCHING_ACTIVITYLOG);

            if (state.items) {
                const moreItems = action.data.items.map(item => new ActivityLog(item)).reduce((acc, current) => {
                    if (!state.items.some(item => item.id === current.id)) {
                        acc.push(current);
                    }
                    return acc;
                }, []);
                state.items = [...moreItems, ...state.items];
            } else {
                state.items = action.data.items.map(item => new ActivityLog(item));
            }
            state.continuationToken = action.data.continuationToken;
            return { ...state };

        case ActionTypes.FETCH_ACTIVITYLOG_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== Loadings.FETCHING_ACTIVITYLOG);
            return { ...state };

        default:
            return state;
    }
};
export default ActivityLogReducer;